// extracted by css-extract-rspack-plugin
export default {"spinBox":"spinBox___aAoEb"};